const routes = {
  '/': 'Home',
  '/users': 'Users',
  '/users/create' : 'Create',
  '/users/manage' : 'Manage',
  '/users/invite' : 'Invite',
  '/users/groups' : 'Groups',
  '/users/educators' : 'Educators',
  '/users/students' : 'Students',
  '/signin': 'Sign In',
  '/home': 'Home',
  '/content': 'Content',
  '/content/manage': 'Manage',
  '/content/create': 'Create',
  '/content/sets': 'Sets',
  '/content/knowledge-map': 'Knowledge Map',
  '/assignments': 'Assignments',
  '/assignments/manage': 'Manage',
  '/assignments/view': 'View',
  '/assessment': 'Practice Testing',
  '/assessment/dashboard': 'Dashboard',
  '/assessment/testing': 'Testing',
  '/assessment/reports': 'Reports',
  '/invites': 'Invites',
  '/register': 'Register',
  '/reset': 'Reset Password',
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js